import { type ReactNode } from 'react';
import { tv } from 'tailwind-variants';
import { panelLead, panelTitle } from './panelHeader.styles.js';

const root = tv({
  base: [
    'an-card',
    'flex h-full min-h-0 min-w-0 flex-col gap-3 overflow-hidden',
    'border-[var(--color-rail-card-border,var(--color-an-border))]',
    'shadow-sm',
  ].join(' '),
});

const header = tv({
  base: 'an-card-header mb-0 flex items-start justify-between gap-2',
});

export interface AnalyticsWidgetCardProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly infoSlot?: ReactNode;
  readonly action?: ReactNode;
  readonly children: ReactNode;
  readonly className?: string;
  readonly testId?: string;
  readonly busy?: boolean;
}

/**
 * Shared analytics / command-center widget chrome — matches DataTableShell
 * (rail border + shadow-sm) with DESIGN_CONTRACT panel title scale.
 */
export function AnalyticsWidgetCard({
  title,
  subtitle,
  infoSlot,
  action,
  children,
  className,
  testId,
  busy = false,
}: AnalyticsWidgetCardProps): JSX.Element {
  return (
    <section
      className={root({ className })}
      data-testid={testId}
      aria-busy={busy ? true : undefined}
    >
      <header className={header()}>
        <div className="flex min-w-0 flex-1 items-start gap-1.5">
          <div className="min-w-0">
            <h2 className={panelTitle({ className: 'text-base' })}>{title}</h2>
            {subtitle != null && subtitle.length > 0 ? (
              <p className={panelLead({ className: 'mt-0.5 text-xs' })}>{subtitle}</p>
            ) : null}
          </div>
          {infoSlot}
        </div>
        {action != null ? <div className="shrink-0 pt-0.5">{action}</div> : null}
      </header>
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </section>
  );
}
